import React, { Component } from "react";
import { BeatLoader } from "react-spinners";

class LocalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this._resetTimer = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // New Relic isn't loaded in dev, so guard it — an unguarded call throws inside the boundary itself,
    // which is unrecoverable and white-screens the app, masking the real error.
    window.newrelic?.noticeError?.(error);
    console.error("LocalErrorBoundary caught:", error, errorInfo);
    if (this._resetTimer) {
      clearTimeout(this._resetTimer);
    }
    this._resetTimer = setTimeout(() => {
      this.setState({ hasError: false, error: null });
      this._resetTimer = null;
    }, 300);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="w-full flex items-center gap-2 text-zinc-500"
          role="alert"
          aria-live="polite"
        >
          <BeatLoader size={6} color="gray" />
        </div>
      );
    }

    return this.props.children;
  }
}

export default LocalErrorBoundary;
